import { BackgroundCheck } from "@wingspanhq/wingspan-api-sdk";

import {
  ContextItem,
  RequirementContextType,
  RequirementStatusViewProps,
  RequirementTableItemData
} from "../../../../types";

import { getBackgroundCheckRequirementStatus } from "./getBackgroundCheckRequirementStatus";

export const getBackgroundCheckPayerRequirementStatus = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem,
  backgroundCheck: BackgroundCheck | undefined
): RequirementStatusViewProps => {
  return getBackgroundCheckRequirementStatus(
    requirement,
    contextItem,
    backgroundCheck,
    RequirementContextType.Payee
  );
};
